import { createQueryData } from '../helpers/createQueryData';

const endPoint =
  'Acceptance/available_acceptance_status_address_life_cycle_by_address_id';

const { useQuery } = createQueryData({ endPoint });

const useRoomAcceptanceStatusesQuery = ({
  params: { addressId } = {},
  options,
}) => {
  return useQuery({
    params: { addressId },
    options: {
      enabled: Boolean(addressId),
      staleTime: 0,
      ...options,
    },
  });
};

export { useRoomAcceptanceStatusesQuery };
